import keyBy from 'lodash/keyBy'
import { useMemo } from 'react'
import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'
import { isDefined } from '@omnea-app/packages/universal/type-guards/isDefined'
import { useGetAutoFlaggedScoreCategories } from './useGetAutoFlaggedScoreCategories'

export const useAutoFlaggedCategoryNames = (categoryIds?: string[]): { names: string[]; isLoading: boolean } => {
  const { data, isLoading } = useGetAutoFlaggedScoreCategories()
  const { TPRM } = useFeatureFlags()

  const names = useMemo(() => {
    const categories = data?.categories ?? []

    const categoriesById = keyBy(categories, 'id')

    const defaultCategoryName = categories.find((c) => c.isDefault)?.name
    if (!categoryIds?.length) {
      return defaultCategoryName ? [defaultCategoryName] : []
    }

    return categoryIds.map((id) => categoriesById[id]?.name).filter(isDefined)
  }, [categoryIds, data?.categories])

  // This feature is only available with TPRM module
  if (!TPRM) {
    return { names: [], isLoading: false }
  }

  return { names, isLoading }
}
